// eslint-disable-next-line ember/no-classic-components
import Component from '@ember/component';

/**
 * Multiple select row.
 * @param {Array<Location|SkinnyLocation>}       selectedLocations  Current selected option ids `1,2,3`.
 * @param {Location|SkinnyLocation}              location
 * @param {Function}                             onSelected         Function triggered when an option is selected
 */

export default class MultiLocationsSelectorLocationRowComponent extends Component {
  tagName = '';
}
